__turbopack_context__.v({
  "assignee": "jHpcbW_assignee",
  "assigneeEditable": "jHpcbW_assigneeEditable",
  "confirm": "jHpcbW_confirm",
  "confirmActions": "jHpcbW_confirmActions",
  "contextLink": "jHpcbW_contextLink",
  "dueEditable": "jHpcbW_dueEditable",
  "duePill": "jHpcbW_duePill",
  "dueShifted": "jHpcbW_dueShifted",
  "editable": "jHpcbW_editable",
  "inboxGrid": "jHpcbW_inboxGrid",
  "inboxRow": "jHpcbW_inboxRow",
  "meta": "jHpcbW_meta",
  "titleLine": "jHpcbW_titleLine",
  "titleSlot": "jHpcbW_titleSlot",
  "trash": "jHpcbW_trash",
});
